import { ColumnTable, TextOutlinedInput } from '@octano/global-ui';
import { useMemo } from 'react';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { StudyPlanVersionOfferItem } from '../../api/partnership';
import { PercentageFormatter } from '../../../../../utils/currency';

const prefix = 'tariffAndTuition.partnerships';

interface OfferRow extends StudyPlanVersionOfferItem {
  discountKey: string;
  defaultValue: string;
}

interface PartnershipFormValues {
  name: string;
  typeId: string;
  description: string;
  applyAutomatically: boolean;
  discounts: { [key: string]: string };
}

interface UsePartnershipOfferColumnsProps {
  control: Control<PartnershipFormValues>;
}

export function usePartnershipOfferColumns({
  control,
}: UsePartnershipOfferColumnsProps) {
  const { t } = useTranslation();

  const columns: ColumnTable<OfferRow>[] = useMemo(
    () => [
      {
        columnName: 'studyPlan',
        headerText: t(`${prefix}.studyPlan`),
        thClassName: 'text-left',
        tdClassName: 'text-left',
        cellFormat: ({ row }) => row.studyPlanVersion?.studyPlan?.name || '-',
      },
      {
        columnName: 'campus',
        headerText: t(`${prefix}.campus`),
        thClassName: 'text-left',
        tdClassName: 'text-left',
        cellFormat: ({ row }) => row.campus?.name || '-',
      },
      {
        columnName: 'schedule',
        headerText: t(`${prefix}.schedule`),
        thClassName: 'text-left',
        tdClassName: 'text-left',
        cellFormat: ({ row }) => row.schedule?.name || '-',
      },
      {
        columnName: 'discountPercentage',
        headerText: t(`${prefix}.discountPercentage`),
        thClassName: 'text-center',
        tdClassName: 'text-center',
        width: '120px',
        cellFormat: ({ row }) => (
          <div
            style={{
              width: '85px',
              display: 'flex',
              alignItems: 'center',
              gap: '2px',
            }}
          >
            <TextOutlinedInput
              name={`discounts.${row.discountKey}` as any}
              control={control}
              defaultValue={PercentageFormatter(row.defaultValue)}
              placeholder="0"
              textAlign="center"
              formatter={(value: string) => PercentageFormatter(value)}
            />
            <span style={{ fontWeight: 500 }}>%</span>
          </div>
        ),
      },
    ],
    [t, control],
  );

  return columns;
}

export type { OfferRow };
